import { createUrl } from '@/routes/utils.ts';
import { PrivateRotes } from '@/routes/private-rotes.ts';

export const DASHBOARD_ROUTES = {
  DASHBOARD: createUrl('dashboard', PrivateRotes.APP),
};
